import { Skeleton } from "@/components/ui/skeleton";

const IndexSkeleton = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Hero Section Skeleton */}
      <section className="min-h-screen flex flex-col items-center justify-center px-6 py-16 md:py-20">
        <div className="max-w-3xl mx-auto text-center w-full">
          {/* Eyebrow */}
          <Skeleton className="h-4 w-48 mx-auto mb-6 bg-tan/30" />

          {/* Main headline */}
          <Skeleton className="h-12 md:h-16 w-3/4 mx-auto mb-6 bg-tan/30" />

          {/* Subheadline */}
          <div className="space-y-2 mb-8">
            <Skeleton className="h-6 w-full mx-auto bg-tan/20" />
            <Skeleton className="h-6 w-5/6 mx-auto bg-tan/20" />
          </div>

          {/* Price badge */}
          <Skeleton className="h-12 w-56 mx-auto mb-10 rounded-full bg-tan/30" />

          {/* CTA buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Skeleton className="h-14 w-48 rounded-md bg-primary/30" />
            <Skeleton className="h-12 w-40 rounded-md bg-tan/30" />
          </div>
        </div>
      </section>

      {/* Sample Letters Section Skeleton */}
      <section className="py-16 md:py-24 px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          {/* Section header */}
          <div className="text-center mb-12">
            <Skeleton className="h-4 w-32 mx-auto mb-3 bg-tan/30" />
            <Skeleton className="h-10 w-64 mx-auto mb-4 bg-tan/30" />
            <Skeleton className="h-5 w-80 mx-auto bg-tan/20" />
          </div>

          {/* Letter card skeleton */}
          <div className="bg-cream-dark/50 rounded-lg p-6 md:p-8">
            <div className="flex justify-between mb-6">
              <div>
                <Skeleton className="h-3 w-20 mb-2 bg-tan/30" />
                <Skeleton className="h-8 w-32 bg-primary/30" />
              </div>
              <Skeleton className="h-12 w-12 md:h-16 md:w-16 rounded border-2 border-dashed border-tan/30 bg-transparent" />
            </div>
            <div className="space-y-3 pl-4 border-l-2 border-tan/30">
              <Skeleton className="h-5 w-full bg-tan/20" />
              <Skeleton className="h-5 w-full bg-tan/20" />
              <Skeleton className="h-5 w-5/6 bg-tan/20" />
              <Skeleton className="h-5 w-4/5 bg-tan/20" />
            </div>
          </div>

          {/* Carousel dots skeleton */}
          <div className="flex items-center justify-center gap-4 mt-8">
            <Skeleton className="h-10 w-10 rounded-full bg-tan/30" />
            <div className="flex gap-2">
              <Skeleton className="h-2 w-8 rounded-full bg-primary/40" />
              <Skeleton className="h-2 w-2 rounded-full bg-tan/30" />
              <Skeleton className="h-2 w-2 rounded-full bg-tan/30" />
            </div>
            <Skeleton className="h-10 w-10 rounded-full bg-tan/30" />
          </div>
        </div>
      </section>
    </div>
  );
};

export default IndexSkeleton;
